import { Button } from "react-bootstrap";
import { AppLoader } from "./AppLoader";

const AppButton = ({
  isLoading = false,
  text = "Submit",
  onClick = () => {},
  type = "button",
  className = "",
  childClass = "",
  variant = "primary",
  disabled = false,
}) => {
  return (
    <Button
      className={`app-btn ${className}`}
      type={type}
      onClick={onClick}
      variant={variant}
      disabled={isLoading || disabled}
    >
      {isLoading ? (
        <span className={`btn-content ${childClass}`}>
          <AppLoader />
          <span>{text}</span>
        </span>
      ) : (
        text
      )}
    </Button>
  );
};

export default AppButton;
